import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { StoreResponseDto, StoreService } from 'src/generated_client';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
})
export class MyAccountComponent implements OnInit {

  isClosed: boolean;
  storeLogin: StoreResponseDto;

  constructor(
    public storeService: StoreService,
    public authService: AuthService,
    public alert: AlertService,
    public loading: LoadingService,
    private router: Router,
    private menu: MenuController
  ) {
    this.menu.enable(true, 'custom');
  }

  ngOnInit() {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.loading.presentLoading();

    this.storeLogin = this.authService.currentUserStore();

    this.storeService.apiStoreGetOneStoreGet(this.storeLogin.cdStore).subscribe(response => {
      this.isClosed = !response.isOpen;
      this.loading.dismiss();
    });
  }

  openCloseStore() {

    this.loading.presentLoading();

    this.storeService.apiStoreOpenOrCloseStorePut(this.storeLogin.cdStore, !this.isClosed).subscribe(response => {      
      this.loading.dismiss();
      this.router.navigateByUrl('/my-account');
    }, error => {
      this.alert.presentAlertOneBtn('Error', 'Ocurrió un error y los cambios no pudieron guardarse', 'Aceptar')
      this.loading.dismiss();
    })
  }

  logout() {
    this.authService.logoutStore();
  }
}